// extracted by mini-css-extract-plugin
export default {"deviceButton":"WhiteboardButton_deviceButton__C5NfI","icon":"WhiteboardButton_icon__O63yA"};